"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Dropdown;

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.regexp.to-string.js");

var _DropdownModule = _interopRequireDefault(require("../../assets/styles/components/Dropdown.module.scss"));

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Dropdown(_ref) {
  let {
    tabIndex,
    error = false,
    positive = false,
    onChange,
    keepSelectedItem = false,
    size = "default",
    options = [],
    selected = [],
    type,
    isMulti = false,
    isClearable = false,
    isSearchable = true,
    placeholder = "Select...",
    disabled = false,
    styling = {},
    hideIcon = false,
    direction = "bottom"
  } = _ref;
  (0, _react.useEffect)(() => {
    document.addEventListener("click", onClickOutside);
  }, []);
  const dropDownRef = (0, _react.useRef)(null);

  const onClickOutside = e => {
    if (dropDownRef.current) {
      if (e.target === dropDownRef.current || dropDownRef.current.contains(e.target)) {//Click inside
      } else {
        //Click outside
        setdropdown_isOpened(false);
      }
    }
  };

  const [dropdown_isOpened, setdropdown_isOpened] = (0, _react.useState)(false);
  const [filtered_opts, setfiltered_opts] = (0, _react.useState)([]);
  const [opts, setopts] = (0, _react.useState)([]);
  const [slct, setslct] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    if (options && selected) {
      reloadValues(options, selected);
    }
  }, [options, selected]);

  const reloadValues = (optionArr, selectArr) => {
    //Default values to values for dropdown
    let tmp_opts = [];

    for (let i = 0; i < optionArr.length; i++) {
      if (type === "ID_LABEL") {
        tmp_opts.push({
          value: optionArr[i].split("_")[0],
          label: optionArr[i].split("_")[1]
        });
      } else {
        tmp_opts.push({
          value: optionArr[i],
          label: optionArr[i]
        });
      }
    } //Default values to values for dropdown


    let tmp_slct = [];

    for (let i = 0; i < selectArr.length; i++) {
      if (type === "ID_LABEL") {
        tmp_slct.push({
          value: selectArr[i].split("_")[0],
          label: selectArr[i].split("_")[1]
        });
      } else {
        tmp_slct.push({
          value: selectArr[i],
          label: selectArr[i]
        });
      }
    } //Remove selected values from options


    if (keepSelectedItem === false) {
      for (let i = 0; i < tmp_slct.length; i++) {
        const index = tmp_opts.findIndex(v => v.value === tmp_slct[i].value);

        if (index > -1) {
          tmp_opts.splice(index, 1);
        }
      }
    }

    setfiltered_opts(tmp_opts);
    setopts(tmp_opts);
    setslct(tmp_slct);
  };

  const selectValue = v => {
    let tmp_slct = [...slct];
    let tmp_opts = []; //Add to selected

    if (isMulti) {
      tmp_slct.push(v);
    } else {
      tmp_slct = [v];
    } //Reset options


    for (let i = 0; i < options.length; i++) {
      if (type === "ID_LABEL") {
        tmp_opts.push({
          value: options[i].split("_")[0],
          label: options[i].split("_")[1]
        });
      } else {
        tmp_opts.push({
          value: options[i],
          label: options[i]
        });
      }
    } //Remove from options


    if (keepSelectedItem === false) {
      for (let i = 0; i < tmp_slct.length; i++) {
        //const index = tmp_opts.findIndex(value => value.value === tmp_slct[i].value)
        const index = tmp_opts.findIndex(vo => JSON.stringify(vo) === JSON.stringify(tmp_slct[i]));

        if (index > -1) {
          tmp_opts.splice(index, 1);
        }
      }
    }

    setsearchValue("");
    setfiltered_opts(tmp_opts);
    setopts(tmp_opts);
    setslct(tmp_slct);
    onChange(v);
  };

  const clearSelected = () => {
    reloadValues(options, []);
  };

  const [searchValue, setsearchValue] = (0, _react.useState)("");

  const searchOption = string => {
    setsearchValue(string);
    let tmp_opts = [...opts];
    let filtered_opt = [];

    for (let i = 0; i < tmp_opts.length; i++) {
      if (tmp_opts[i].label.toString().toLowerCase().includes(string.toString().toLowerCase()) || tmp_opts[i].value.toString().toLowerCase().includes(string.toString().toLowerCase())) {
        filtered_opt.push(tmp_opts[i]);
      }
    }

    setfiltered_opts(filtered_opt);
  };

  const removeOption = v => {
    let tmp_opts = [...opts];
    let tmp_slct = [...slct];
    tmp_opts.push(v);
    const index = tmp_slct.findIndex(value => value.value === v.value);

    if (index > -1) {
      tmp_slct.splice(index, 1);
    }

    setopts(tmp_opts);
    setslct(tmp_slct);
    setfiltered_opts(tmp_opts);
    setsearchValue("");
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: dropDownRef,
    style: styling,
    className: "\n            ".concat(_DropdownModule.default.inputfield, " \n            ").concat(size === "default" ? _DropdownModule.default.size_default : size === "compact" ? _DropdownModule.default.size_compact : size === "large" ? _DropdownModule.default.size_large : size === "mini" ? _DropdownModule.default.size_mini : _DropdownModule.default.size_default, "\n            ").concat(error === true && _DropdownModule.default.error, "\n            ").concat(positive === true && _DropdownModule.default.positive, "\n        "),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _DropdownModule.default.input_values,
      children: [isMulti && Array.isArray(slct) && slct.map((v, i) => {
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: _DropdownModule.default.multi_value,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: v.label
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
            onClick: () => {
              removeOption(v);
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "black",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
              })]
            })
          })]
        }, i);
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _DropdownModule.default.input_wrapper,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          tabIndex: tabIndex && tabIndex,
          disabled: disabled,
          placeholder: placeholder,
          readOnly: !isSearchable,
          type: "text",
          onFocus: () => {
            setdropdown_isOpened(true);
          },
          value: !isMulti ? searchValue !== "" ? searchValue : slct.length > 0 ? slct[0].label ? slct[0].label : "" : "" : searchValue,
          onChange: e => {
            searchOption(e.currentTarget.value);
          }
        })
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _DropdownModule.default.input_actions,
      children: [isClearable && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        disabled: disabled,
        onClick: () => {
          clearSelected();
        },
        className: _DropdownModule.default.input_action,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "black",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
            x1: "18",
            y1: "6",
            x2: "6",
            y2: "18"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
            x1: "6",
            y1: "6",
            x2: "18",
            y2: "18"
          })]
        })
      }), !hideIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        disabled: disabled,
        onClick: () => {
          setdropdown_isOpened(true);
        },
        className: _DropdownModule.default.input_action,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "black",
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
            points: "6 9 12 15 18 9"
          })
        })
      })]
    }), dropdown_isOpened && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "".concat(_DropdownModule.default.dropdown, " ").concat(direction === "bottom" ? _DropdownModule.default.direction_bottom : direction === "top" ? _DropdownModule.default.direction_top : _DropdownModule.default.direction_bottom),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        id: "action",
        children: Array.isArray(filtered_opts) && filtered_opts.map((v, i) => {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
            id: "action",
            onClick: () => {
              selectValue(v);
            },
            className: _DropdownModule.default.dropdown_option,
            children: v.label
          }, i);
        })
      })
    })]
  });
}